import React from 'react';
import {Card, Flex} from "antd";
import Header from "./Header";
import {ContentCard} from "./Header.styled";

const Conditions = () => {
    return (

            <Flex vertical>
                <Header/>
                <ContentCard>
                    <div>
                        <h3>شرایط و مقررات استفاده از پلتفرم آنلاین اجاره تجهیزات و لوازم « پیدا »</h3>

                        <h4>مقدمه</h4>
                        <p>به پلتفرم آنلاین اجاره تجهیزات و لوازم « پیدا » خوش آمدید.<br/>
                            این سند شرایط و مقررات استفاده از سامانه را تعیین می‌کند و رابطه حقوقی میان ما (سامانه
                            تجهیزات پیدا) و شما (کاربر) را مشخص می‌نماید. استفاده از سامانه به منزله پذیرش کامل تعهدات و
                            شرایط مندرج در این سند است؛ لذا پیش از استفاده، لطفاً به دقت مطالعه نمایید. هدف ما فراهم
                            آوردن بستری امن و شفاف جهت اجاره‌دهی و اجاره‌گیری تجهیزات مختلف است.</p>

                        <h3>فهرست مطالب</h3>
                        <ul>
                            <li>معرفی سامانه</li>
                            <li>شرایط عمومی استفاده از سامانه</li>
                            <li>سیاست‌های ثبت و مدیریت آگهی‌های تجهیزات اجاره‌ای</li>
                            <li>حقوق و تعهدات سامانه</li>
                            <li>تعهدات و مسئولیت‌های کاربر</li>
                            <li>ضمانت اجرایی در برابر تخلفات</li>
                            <li>مالکیت فکری</li>
                            <li>حفاظت از حریم خصوصی</li>
                            <li>حل و فصل اختلافات</li>
                            <li>ارتباط با ما</li>
                        </ul>

                        <h3>۱. معرفی سامانه</h3>
                        <p>پلتفرم آنلاین اجاره تجهیزات و لوازم « پیدا »، پلتفرمی آنلاین است که با هدف تسهیل فرآیند اجاره
                            تجهیزات مختلف (اعم از ابزارآلات صنعتی، تجهیزات پزشکی، تجهیزات زیبایی و غیره) طراحی شده است.
                            این سامانه امکان ثبت، مدیریت و جستجوی آگهی‌های مربوط به تجهیزات اجاره‌ای را در اختیار
                            کاربران قرار می‌دهد.</p>

                        <h3>۲. شرایط عمومی استفاده از سامانه</h3>
                        <p>کاربران جهت بهره‌مندی از خدمات سامانه موظف به ثبت‌نام با استفاده از شماره تلفن همراه فعال و
                            ارائه اطلاعات هویتی صحیح هستند.<br/>
                            ثبت آگهی‌ها و انجام معاملات تنها با ارائه اطلاعات دقیق، به‌روز و مستند مجاز است.<br/>
                            کاربران باید حداقل ۱۸ سال داشته باشند؛ افراد زیر ۱۸ سال تنها با نظارت و تأیید والدین مجاز به
                            استفاده از سامانه خواهند بود.</p>

                        <h3>۳. سیاست‌های ثبت و مدیریت آگهی‌های تجهیزات اجاره‌ای</h3>
                        <p>کاربران در هنگام ثبت آگهی موظفند مشخصات فنی و وضعیت ظاهری تجهیزات (مانند برند، مدل، سال ساخت،
                            تاریخ آخرین سرویس، شرایط عملکردی و سایر ویژگی‌های مرتبط) را درج کنند.<br/>
                            ارائه اطلاعات نادرست یا گمراه‌کننده منجر به حذف آگهی و یا تعلیق حساب کاربری خواهد شد.<br/>
                            هرگونه تکرار آگهی یا انتشار در دسته‌بندی نامناسب ممنوع بوده و ممکن است سامانه حق اقدام جهت
                            اصلاح یا حذف آگهی را داشته باشد.</p>

                        <h3>۴. حقوق و تعهدات سامانه</h3>
                        <p>سامانه تنها به عنوان بستری جهت ارتباط مستقیم میان اجاره‌دهندگان و اجاره‌گیرندگان عمل می‌کند و
                            مسئولیتی در قبال صحت اطلاعات ارائه‌شده یا کیفیت تجهیزات ندارد.<br/>
                            در موارد اختلاف یا بروز مشکل، کاربران موظف به مذاکره مستقیم با یکدیگر هستند؛ در صورت عدم
                            توافق، طرفین (اجاره‌دهنده و اجاره‌گیرنده) حق ارجاع موضوع به کارشناسان مستقل یا مراجع قضایی
                            را خواهند داشت و سامانه موظف به ارائه گزارش رویدادها و تعاملات صورت گرفته در بستر سامانه، به
                            مراجع ذیصلاح خواهد بود.<br/>
                            جهت حفظ امنیت کاربران، در صورت تخلف‌های جدی، سامانه می‌تواند دسترسی کاربر را محدود یا به‌طور
                            موقت/دائم مسدود نماید.</p>

                        <h3>۵. تعهدات و مسئولیت‌های کاربر</h3>
                        <p>کاربر مسئول صحت و کامل بودن اطلاعات وارد شده در آگهی‌های خود است.<br/>
                            پیش از انجام هرگونه معامله، کاربران موظف به بررسی دقیق وضعیت تجهیزات و دریافت اطلاعات لازم
                            از طرف مقابل می‌باشند.<br/>
                            استفاده از سامانه به منزله قبول تمامی تعهدات مندرج در این سند و رعایت قوانین جاری کشور در
                            زمینه معاملات آنلاین است.</p>

                        <h3>۶. ضمانت اجرایی در برابر تخلفات</h3>
                        <p>سامانه حق دارد در صورت مشاهده هرگونه تخلف از شرایط و مقررات، از جمله انتشار اطلاعات مغایر با
                            واقعیت یا نقض قوانین مربوطه، اقدام مقتضی نظیر حذف آگهی یا مسدودسازی حساب کاربری را انجام
                            دهد.<br/>
                            هرگونه خسارت وارده ناشی از تخلف کاربر، بر عهده خود وی خواهد بود.</p>

                        <h3>۷. مالکیت فکری</h3>
                        <p>کلیه حقوق مالکیت فکری مرتبط با نرم‌افزار، طراحی، محتوا و ساختار پلتفرم آنلاین اجاره تجهیزات و
                            لوازم « پیدا » منحصراً متعلق به شرکت برگزارکننده سامانه است.<br/>
                            استفاده یا کپی‌برداری از هر یک از مطالب و طراحی‌های سامانه بدون کسب مجوز کتبی، غیرمجاز است.
                        </p>

                        <h3>۸. حفاظت از حریم خصوصی</h3>
                        <p>اطلاعات شخصی کاربران در هنگام ثبت‌نام و استفاده از سامانه جمع‌آوری و مطابق با قوانین مربوط به
                            حریم خصوصی ذخیره می‌شود.<br/>
                            این اطلاعات تنها به منظور بهبود خدمات و ارتقای سطح امنیت سامانه استفاده و در موارد قانونی در
                            اختیار مراجع ذی‌صلاح قرار می‌گیرد.<br/>
                            کاربران با استفاده از سامانه، موافقت خود را با جمع‌آوری، ذخیره و استفاده از اطلاعات شخصی
                            اعلام می‌دارند.</p>

                        <h3>۹. حل و فصل اختلافات</h3>
                        <p>در صورت بروز هرگونه اختلاف ناشی از استفاده از سامانه یا معاملات انجام‌شده، کاربران ابتدا موظف
                            به تلاش جهت حل مسالمت‌آمیز موضوع هستند.<br/>
                            در صورت عدم توافق، موضوع می‌تواند به کارشناسان مستقل ارجاع شده یا در نهایت به مراجع قضایی
                            تحویل داده شود.<br/>
                            سامانه در موارد اضطراری حق تعیین کارشناسان برای بررسی و حل اختلافات را برای خود محفوظ
                            می‌دارد.</p>

                        <h3>۱۰. ارتباط با ما</h3>
                        <p>کاربران می‌توانند جهت دریافت پشتیبانی و یا ارائه پیشنهادات و شکایات، از طریق بخش تماس و
                            پشتیبانی سامانه یا شماره‌های اعلام‌شده با تیم خدمات مشتریان در ارتباط باشند.<br/>
                            سامانه متعهد به ارائه خدمات پشتیبانی در ساعات مشخص اداری بوده و تلاش می‌کند به بهترین نحو به
                            درخواست‌های کاربران پاسخ دهد.</p>

                        <h3>تأیید و پذیرش شرایط</h3>
                        <p>استفاده از پلتفرم آنلاین اجاره تجهیزات و لوازم « پیدا » به منزله‌ی پذیرش کامل شرایط و مقررات
                            مندرج در این سند تلقی می‌شود.<br/>
                            در صورت عدم پذیرش هر یک از موارد فوق، لطفاً از استفاده از سامانه خودداری نمایید.</p>

                        <p>این نسخه از شرایط و مقررات با هدف تضمین یک فضای امن و کارآمد برای اجاره‌دهندگان و
                            اجاره‌گیرندگان تنظیم شده است.<br/>
                            در صورت بروز هرگونه تغییر در شرایط، سامانه از طریق اطلاع‌رسانی رسمی، کاربران را مطلع خواهد
                            ساخت.</p>
                    </div>

                </ContentCard>

            </Flex>


    );
};

export default Conditions;